import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	title: {
		id: 'directories.filters-v2.delete-modal.title',
		defaultMessage: 'Delete {name}',
		description: 'Title for delete filter modal.',
	},
});
